module.exports = __webpack_public_path__ + "static/media/nasb.e57b600d.jpg";